import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useContext, useState } from 'react';
import { Box, Button } from '@chakra-ui/react';
import { useT } from '@progress-fe/core';
import { Dialog } from '../../base';
import { JsFieldInspector } from '../../jsFormBase';
import { JsFormConfigContext } from '../../../contexts';
import { VisiblePropsDialog } from './components';
/**
 * Component renders "/schemas/jsf-visible-props" field of JsonSchema.
 * @param props : field props come from JsonSchema.
 * Value of props.formData is an instance of TVisiblePropsFormData.
 */
const VisiblePropsJsFieldFC = (props) => {
    const { isInspector } = useContext(JsFormConfigContext) ?? {};
    const [isDialog, setIsDialog] = useState(false);
    const [dialogExcludeIds, setDialogExcludeIds] = useState([]);
    const { t } = useT();
    const formData = structuredClone(props.formData);
    const handleChangeValue = () => {
        const newFormData = {
            ...formData,
            fieldValues: { excludeIds: dialogExcludeIds }
        };
        props.onChange(newFormData);
    };
    const openDialog = () => {
        setDialogExcludeIds(formData.fieldValues.excludeIds);
        setIsDialog(true);
    };
    const closeDialog = () => {
        setIsDialog(false);
        handleChangeValue();
        setDialogExcludeIds([]);
    };
    return (_jsx(JsFieldInspector, { isActive: isInspector, fieldCode: props.name, fieldType: props.uiSchema?.['ui:field']?.toString() ?? '', valueType: ['object'], children: _jsxs(Box, { "data-testid": "VisiblePropsJsField-test", "data-name": props.name, pb: "1px", children: [isDialog && (_jsx(Dialog, { title: t('jsfields.VisibleProps.addProps'), onClose: closeDialog, children: _jsx(VisiblePropsDialog, { config: formData.fieldConfig, excludeIds: dialogExcludeIds, onChangeExcludeIds: setDialogExcludeIds }) })), _jsx(Button, { variant: "ghost", size: "smSquare", width: "100%", onClick: openDialog, children: t('jsfields.VisibleProps.selectProps') })] }) }));
};
export const VisiblePropsJsField = memo(VisiblePropsJsFieldFC);
//# sourceMappingURL=VisiblePropsJsField.js.map